module.exports = __webpack_public_path__ + "files/d7dbc250008cd353f8dfc1b226e2261b.svg";